import { MessagingService } from '../_services/messaging.service';
import { User } from '../_models/user';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AccountService } from '../_services/account.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ohi-university',
  templateUrl: './ohi-university.component.html',
  styleUrls: ['./ohi-university.component.scss']
})
export class OhiUniversityComponent implements OnInit {

  user: User;
  
  constructor(
    private accountService: AccountService,
    public router: Router,
    public messagingService: MessagingService
  ) { 
    this.user = this.accountService.userValue;
  }

  navigate(route: string){        
    this.messagingService.sendMessage({messageType: 1, message: route});   
    this.router.navigateByUrl(route);
  }

  ngOnInit(): void {
  }
}
